import { render, staticRenderFns } from "./organization-logo.vue?vue&type=template&id=44bea26b&scoped=true&"
import script from "./organization-logo.vue?vue&type=script&lang=js&"
export * from "./organization-logo.vue?vue&type=script&lang=js&"
import style0 from "./organization-logo.vue?vue&type=style&index=0&id=44bea26b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bea26b",
  null
  
)

export default component.exports